import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import ActiveNavImage from '../../../images/head-nav-active.png';
import BackgroundImage from '../../../images/flyout-bg.png';

export const MainContainer = styled(Container)`
  height: 116px;
  margin: auto !important;
  width: 1200px !important;
  padding: 0 !important;
  @media (max-width: 1199px) {
    width: 960px !important;
  }
  @media (max-width: 991px) {
    width: 728px !important;
    height: 200px;
    text-align: center;
  }
  @media (max-width: 767px) {
    display: none;
  }
  @media print {
    display: none;
  }
`;

export const TopLogoAnchor = styled.a`
  position: relative;
  z-index: 99;
  float: left;
  width: 461px;
  margin: 31px 0 0 0;
  @media (max-width: 991px) {
    float: none;
    width: 100%;
    text-align: center;
  }
`;

export const TopLogo = styled.img`
  width: 100%;
  height: auto;
  @media (max-width: 991px) {
    width: 462px;
  }
  @media (max-width: 980px) {
    width: 462px;
    height: auto;
    margin-top: 31px;
  }
`;

export const TopNav = styled.div`
  display: block;
  position: relative;
  float: right;
  width: 700px;
  height: 65px;
  margin: 40px 0 0 0;
  padding: 0;
  text-align: end;
  @media (max-width: 1399px) {
    width: 490px;
  }
  @media (max-width: 991px) {
    float: none;
    width: 420px;
    height: 65px;
    margin: 40px auto 0 auto;
  }
`;
export const ListDiv = styled.div`
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 0;
`;

export const HeaderMenu = styled.a`
  display: inline-block;
  height: 65px;
  padding: 14px 18px 0 18px !important;
  line-height: 16px;
  font-size: 16px;
  font-family: Gotham-Medium, arial, sans-serif;
  text-transform: uppercase;
  text-decoration: none;
  letter-spacing: 0;
  color: #083a81 !important;
  &.hoverEffect {
    background: url(${ActiveNavImage});
    background-position: center -57px;
    background-size: auto 102px;
    background-repeat: no-repeat;
    border: none;
  }
  &.active {
    color: #1fb25a !important;
    background: none;
    padding: 14px 18px 0 18px !important;
    @media (max-width: 1199px) {
      padding: 14px 13px 0 13px !important;
    }
    @media (max-width: 991px) {
      padding: 12px 11px 0 11px !important;
    }
  }

  @media (max-width: 1199px) {
    padding: 15px 13px 0 13px !important;
    font-size: 14px;
    line-height: 14px;
  }
  @media (max-width: 991px) {
    padding: 12px 11px 0 11px !important;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0;
  }
`;

export const Layout = styled.div`
  position: absolute;
  box-shadow: 2px 2px 2px rgb(0 0 0 / 10%);
  z-index: 999;
  background: url(${BackgroundImage}) repeat-x bottom left;
  left: 0;
  top: 50px;
  width: 320px !important;
  padding: 0 !important;
  @media (max-width: 991px) {
    margin-top: 15px;
    padding-bottom: 0;
  }
`;

export const InnerLayout = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 20px 0;
`;
export const RightLayout = styled.div`
  float: none;
  width: 100%;
  padding: 0;
`;
export const pStyle = {
  margin: '0 0 30px 0',
  padding: '0',
};
